import axios from "../axiosClient";

export const getAssetModels = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/AssetModel/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};
